




import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getToken } from '@/utils/cookies'
import { defaultImage } from '@/utils/default'

@Component({
  inheritAttrs: false,
})
export default class extends Vue {
  @Prop({ required: true }) private src!: string // Original image URL

  public blobUrl: string | null = null

  public async mounted() {
    await this.fetchImage(this.src)
  }

  private async fetchImage(url: string) {
    try {
      console.log('Fetching image from:', url)
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ` + getToken(),
        },
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`)
      }

      const blob = await response.blob()
      this.blobUrl = URL.createObjectURL(blob)
    } catch (error) {
      console.error('Error fetching image:', error)
      this.blobUrl = defaultImage // Fallback using publicPath
    }
  }

  @Watch('src') // Watch for changes to the `src` prop
  public async onSrcChange(newSrc: string) {
    console.log('src changed to:', newSrc)
    await this.fetchImage(newSrc) // Fetch the new image when `src` changes
  }

  public beforeDestroy() {
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl) // Clean up the blob URL
    }
  }
}
